module.exports = __webpack_public_path__ + "img/one.4f97cd43.png";